import React, { forwardRef } from 'react';

const InputApple = forwardRef(({
  label,
  error,
  hint,
  icon: Icon,
  iconPosition = 'left',
  className = '',
  containerClassName = '',
  type = 'text',
  ...props
}, ref) => {
  const inputClasses = [
    'apple-input',
    Icon && iconPosition === 'left' ? 'pl-10' : '',
    Icon && iconPosition === 'right' ? 'pr-10' : '',
    error ? 'error' : '',
    className,
  ].filter(Boolean).join(' ');

  const isTextarea = type === 'textarea';
  const isSelect = type === 'select';

  return (
    <div className={`apple-input-group ${containerClassName}`}>
      {label && (
        <label className="apple-label">
          {label}
        </label>
      )}
      <div className="relative">
        {Icon && iconPosition === 'left' && (
          <Icon 
            size={18} 
            className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" 
          />
        )}
        
        {isTextarea ? (
          <textarea
            ref={ref}
            className={`${inputClasses} apple-textarea`}
            {...props}
          />
        ) : isSelect ? (
          <select
            ref={ref}
            className={`${inputClasses} apple-select`}
            {...props}
          />
        ) : (
          <input
            ref={ref}
            type={type}
            className={inputClasses}
            {...props}
          />
        )}
        
        {Icon && iconPosition === 'right' && (
          <Icon 
            size={18} 
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" 
          />
        )}
      </div>
      
      {error && (
        <p className="apple-input-error">{error}</p>
      )}
      
      {hint && !error && (
        <p className="mt-1 text-xs text-gray-500">{hint}</p>
      )}
    </div>
  );
});

InputApple.displayName = 'InputApple';

export default InputApple;
